import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { MainLayout } from './components/layout/MainLayout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { LoginPage } from './pages/auth/LoginPage'
import { RegisterPage } from './pages/auth/RegisterPage'
import { DashboardPage } from './pages/dashboard/DashboardPage'
import { ApiKeysPage } from './pages/api-keys/ApiKeysPage'
import { BillingPage } from './pages/billing/BillingPage'
import { UsagePage } from './pages/usage/UsagePage'
import { DevicesPage } from './pages/devices/DevicesPage'
import { ChannelsPage } from './pages/admin/channels/ChannelsPage'
import { ModelsPage } from './pages/admin/models/ModelsPage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminAnalyticsPage } from './pages/admin/AdminAnalyticsPage'
import { AuditLogPage } from './pages/admin/AuditLogPage'

function App() {
  const { isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/api-keys" element={<ApiKeysPage />} />
                <Route path="/devices" element={<DevicesPage />} />
                <Route path="/usage" element={<UsagePage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route
                  path="/admin/users"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminUsersPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/channels"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <ChannelsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/models"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <ModelsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/analytics"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminAnalyticsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/audit-logs"
                  element={
                    <ProtectedRoute requiredRole="admin">
                      <AuditLogPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default App
